import { createContext, useContext } from "react";

type TResetFunction = () => void;

interface IFiltersContextType {
  registerResetFn: (fn: TResetFunction) => void;
}

export const FiltersContext = createContext<IFiltersContextType>({
  registerResetFn: () => {},
});

export function useFilters() {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error("useFilters must be used within FiltersProvider");
  }
  return context;
}
